import { SearchCriteria } from 'src/app/core/interfaces/search-criteria.interface';
import { CollectionFinderItemDTO } from 'src/app/core/interfaces/collection.interface';
import { FIELD_PRIORITY_WEIGHT, SEARCH_FIELD, SearchPriorityConfig } from 'src/app/core/interfaces/search-priority-config';

export class CollectionTitleCriteria implements SearchCriteria {
  getMatchScore(_collection: CollectionFinderItemDTO, _query: string): number {
    
    const title = _collection.title?.toLowerCase() ?? '';
    
    if(title === _query) {
      return 5;
    }
    if(title?.startsWith(_query)) {
      return 3;
    }
    if(title?.includes(_query)) {
      return 1;
    }
    return  0;
  }

  getRelevanceFieldWeightAndMatchScore(_collection: CollectionFinderItemDTO, _query: string): SearchPriorityConfig {
    return {
      relevanceField: SEARCH_FIELD.TITLE,
      fieldPriorityWeight: FIELD_PRIORITY_WEIGHT.TITLE,
      matchScore: this.getMatchScore(_collection, _query)
    }
  }
}
